import { ReportsContext } from '@/dashboards/Reports/providers';
import { useContext } from 'use-context-selector';

export const useReportsContext = () => useContext(ReportsContext);
